<template>
  <div class="analytics-resubmitted-report">
    <div class="columns is-multiline">
      <div class="column">
        <h3>Re-submitted reports by country</h3>
      </div>
      <div class="column report-date-picker">
        <label class="calander-label">From </label>
        <b-datepicker
          class="analytics-date-picker actual-submission-start-date"
          v-model="actual_submission_start_from_date"
          required
          icon="calendar-today"
          trap-focus
          v-on:input="getByDate"
        >
        </b-datepicker>

        <label class="calander-label">To </label>
        <b-datepicker
          class="analytics-date-picker"
          v-model="actual_submission_end_to_date"
          position="is-bottom-left"
          required
          icon="calendar-today"
          trap-focus
          v-on:input="getByDate"
        >
        </b-datepicker>
      </div>
    </div>

    <apexchart
      v-if="series.length > 0 && chartOptions"
      type="bar"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import analyticsSerice from "@/services/AnalyticsService";
import utitlityMixin from "@/mixins/UtilityMixin";
// @group Analytics
export default {
  name: "AnalyticsView",
  mixins: [utitlityMixin],
  data() {
    return {
      switchCustomerId: null,
      actual_submission_end_to_date: this.currentDate(),
      actual_submission_start_from_date: this.sixMonthsBefore(),
      year: this.currentYear(),
      analyticsSerice: new analyticsSerice(),
      series: [],
      chartOptions: {}
    };
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    this.getReportTrackerResubmittedReport(this.currentYear());
  },
  methods: {
    getByDate() {
      this.year = null;
      this.getReportTrackerResubmittedReport(this.year);
    },

    getReportTrackerResubmittedReport(year) {
      const start_date = this.dateFormatterNew(
        this.actual_submission_start_from_date
      );
      const end_date = this.dateFormatterNew(
        this.actual_submission_end_to_date
      );

      if (start_date != null && end_date != null && start_date >= end_date) {
        alert("end date should be greater than start date");
        return false;
      }
      this.analyticsSerice
        .getReportTrackerResubmittedReport(
          year,
          this.switchCustomerId,
          this.dateFormatterNew(this.actual_submission_start_from_date),
          this.dateFormatterNew(this.actual_submission_end_to_date)
        )
        .subscribe(
          response => {
            this.series = response;
            const length = response[0].data.length;
            const maxlengthArray = [];
            for (let i = 1; i < response.length; i++) {
              response[i].data = response[i].data.slice(0, length);
              maxlengthArray[i] = Math.max(...response[i].data);
            }
            const maxlength = maxlengthArray.reduce((a, b) => a + b, 0);
            this.chartOptions = {
              chart: {
                type: "bar",
                stacked: true,
                height: 450,
                toolbar: {
                  show: true
                },
                zoom: {
                  enabled: false
                }
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  borderRadius: 0
                }
              },
              xaxis: {
                type: "text",
                categories: response.shift().data
              },
              yaxis: {
                min: 0,
                max: maxlength > 0 ? maxlength + 2 : 5,
                labels: {
                  formatter: function(val) {
                    return val.toFixed(0);
                  }
                }
              },
              fill: {
                opacity: 1,
                colors: ["#00d1b2", "#FF8000", "000000"]
              },
              legend: {
                position: "top",
                showForSingleSeries: true,
                showForNullSeries: true,
                showForZeroSeries: true,
                labels: {
                  colors: ["#00d1b2", "#FF8000", "000000"]
                },
                onItemClick: {
                  toggleDataSeries: false
                }
              }
            };
          },
          error => {
            console.log("error loading data");
          }
        );
    }
  }
};
</script>
